module.exports = __webpack_public_path__ + "media/images/miscellaneous_icons/location-icon-41c26df49d96dbadd6012b1b2d943a07.png";